import { LanguageCode } from '../types';

export interface ResearchGroupTranslation {
  research_group_id?: string;
  language: LanguageCode;
  invitation: string;
  id?: string;
}
